<template>
    <div class="page page-exam-tab">
        <div class="weui-tab">
            <div class="weui-navbar">
                <div class="weui-navbar__item" :class="{ 'weui-bar__item_on': activeTab == 'user' }"
                    @click="activeTab = 'user'">
                    我的考试
                </div>
                <div class="weui-navbar__item" :class="{ 'weui-bar__item_on': activeTab == 'exam' }"
                    @click="activeTab = 'exam'">
                    考试管理
                </div>
            </div>
            <div class="weui-tab__panel" v-if="activeTab == 'user'">
                <exam-user-list ref="userList" />
            </div>
            <div class="weui-tab__panel" v-if="activeTab == 'exam'">
                <exam-list ref="examList" />
            </div>
        </div>
    </div>
</template>

<script>
import ExamUserList from "@/views/oa/ExamUserList.vue";
import ExamList from "@/views/oa/ExamList.vue";

export default {
    components: {
        ExamUserList,
        ExamList
    },
    data() {
        return {
            activeTab: "user"
        };
    },
    watch: {
        activeTab(val) {
            this.$nextTick(() => this.$refs[val + 'List'].onSearch())
        }
    },
    mounted() {
        this.$refs[this.activeTab + 'List'].onSearch()
    }
};
</script>

<style>
.page-exam-tab .weui-navbar {
    background-color: var(--weui-BG-2);
    justify-content: space-around;
}

.page-exam-tab .weui-navbar__item.weui-bar__item_on {
    background-color: var(--weui-BG-2);
    color: #07c160;
    border-color: #07c160;
}

.page-exam-tab .weui-navbar__item {
    border-bottom: 2px solid transparent;
    padding: 5px 0;
    color: var(--weui-FG-0);
    font-size: 12px;
    flex: auto;
}

.page-exam-tab .weui-navbar:after,
.page-exam-tab .weui-navbar__item:after {
    content: none;
}

.page-exam-tab .weui-tab {
    flex: 1;
    overflow: hidden;
}

.page-exam-tab .weui-tab__panel {
    display: flex;
    flex-direction: column;
    position: relative;
}
</style>